// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"Blog_blogContainer__RP0Mq","section":"Blog_section__158tK","blog":"Blog_blog__23vBx"};